// @ts-nocheck
import React from 'react';
import Box from '@mui/material/Box';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import SinapThemev2 from "../styles/SinapThemev2";
import { ThemeProvider, StyledEngineProvider, styled } from '@mui/material/styles';
import { MaterialReactTable, MRT_ActionMenuItem, useMaterialReactTable } from "material-react-table";

export default function Tabla({ ...props }) {

    return (
        <Box>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={SinapThemev2}>
                    <MaterialReactTable
                        muiCircularProgressProps={{ style: { display: 'none' } }}
                        {...props}
                        localization={MRT_Localization_ES}
                    />
                </ThemeProvider>
            </StyledEngineProvider>
        </Box>
    );
}
